import MainLayout from "@/components/layout/MainLayout";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { useTranslation } from "react-i18next";

interface LoadingStateProps {
  message?: string;
}

export const LoadingState = ({ message }: LoadingStateProps) => {
  const { t } = useTranslation();
  return (
    <MainLayout>
      <div className="container-page">
        <LoadingSpinner message={message || t('records.loading.default')} />
      </div>
    </MainLayout>
  );
};